import cx from "classnames";
import React from "react";
import * as styles from "./withSafeRotateSvg.module.scss";

export interface RotateProps {
	rotation?: number;
	className?: string;
	height?: string;
	width?: string;
}

export const withSafeRotateSvg =
	<P extends object>(SvgComponent: React.FC<P>): React.FC<P & RotateProps> =>
	({ className, height, width, rotation = 0, ...props }: RotateProps) => (
		<SvgComponent
			{...(props as P)}
			height={height}
			width={width}
			className={cx(styles.rotatingSvg, className)}
			style={{
				transform: `rotate(${rotation}deg)`,
				"--webkit-transform": `rotate(${rotation}deg)`,
			}}
		/>
	);
